import type { ICMSBlockViewModel } from '../../types/cms-block.viewModel';
import type { HowToArriveBlock } from '@/src/cms/domain/models/blocks/how-to-arrive-block';

export class HowToArriveBlockViewModel implements ICMSBlockViewModel {
  readonly $type = 'how-to-arrive-block' as const;

  hide: boolean;
  title: string;
  address: string | null;
  bus: string | null;
  subway: string | null;
  airport: string | null;
  latitude: number | null;
  longitude: number | null;
  link: string | null;

  constructor(data: {
    hide: boolean;
    title: string;
    address: string | null;
    bus: string | null;
    subway: string | null;
    airport: string | null;
    latitude: number | null;
    longitude: number | null;
    link: string | null;
  }) {
    this.hide = data.hide;
    this.title = data.title;
    this.address = data.address;
    this.bus = data.bus;
    this.subway = data.subway;
    this.airport = data.airport;
    this.latitude = data.latitude;
    this.longitude = data.longitude;
    this.link = data.link;
  }

  static presenter(block: HowToArriveBlock): HowToArriveBlockViewModel {
    return new HowToArriveBlockViewModel({
      hide: block.hide,
      title: block.title,
      address: block.address,
      bus: block.bus,
      subway: block.subway,
      airport: block.airport,
      latitude: block.latitude,
      longitude: block.longitude,
      link: block.link
    });
  }
}
